<mat-dialog-actions [align]="'end'">
  <button matButton (click)="handleClose()" aria-label="Close dialog">
    <mat-icon inline class="x-icon close-icon">close</mat-icon>
  </button>
</mat-dialog-actions>
<app-load-spinner-wrapper [loading]="loading">
  <ng-container
    *ngIf="readOnlyMode; then readOnlyModeTemplate; else editModeTemplate">
  </ng-container>
</app-load-spinner-wrapper>

<ng-template #editModeTemplate>
  <div *ngIf="clinicsList.length > 0 && providersList.length > 0" class="user-info-modal">
    <h1 class="text-2xl">{{userDetails?.firstName}} {{userDetails?.lastName}}</h1>
    <ng-container *ngIf="userDetails.lastLogin !== null"><p class="mt-2">
      <strong>Last Login:</strong> {{userDetails.lastLogin | dateFormat}}</p></ng-container>
    <ng-container *ngTemplateOutlet="personalInfoEditModeTemplate;"></ng-container>
    <ng-container *ngTemplateOutlet="companyInfoEditModeTemplate;"></ng-container>
    <ng-container *ngIf="userAccountType !== AllAccountTypes.REFERRAL_PARTNER">
      <ng-container *ngTemplateOutlet="caseContactSection;"></ng-container>
    </ng-container>
    <ng-container *ngIf="userAccountType === AllAccountTypes.REFERRAL_PARTNER">
      <ng-container *ngTemplateOutlet="clinicProviderInfoEditModeTemplate;"></ng-container>
    </ng-container>
  </div>
  <div mat-dialog-actions class="action-items-container">
    <app-secondary-action-button
      [buttonText]="'Cancel'"
      (clickEmitter)="onCancel()">
    </app-secondary-action-button>
    <app-primary-action-button
      [buttonText]="'Save'"
      [disabled]="!anyUnsavedChanges"
      (clickEmitter)="onSave()">
    </app-primary-action-button>
  </div>
</ng-template>

<ng-template #personalInfoEditModeTemplate>
  <div class="mt-4">
    <h2 class="text-lg mb-1"><strong>Personal Information:</strong></h2>
    <hr class="bg-green mb-2" style="height: 2px;"/>
    <p>
      <strong>User Type:</strong> {{userAccountTypeId | accountTypeName}}
    </p>
    <form [formGroup]="personalInfoForm">
      <p class="mt-4"><strong>Email Address:</strong></p>
      <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
        <input matInput type="email" formControlName="email"/>
        <mat-error *ngIf="personalInfoForm.get('email')?.hasError('required')">
          Email is required.
        </mat-error>
        <mat-error *ngIf="personalInfoForm.get('email')?.hasError('emailTaken')">
          Email is not available.
        </mat-error>
        <mat-error *ngIf="personalInfoForm.get('email')?.hasError('email') && !personalInfoForm.get('email')?.hasError('required')">
          Please enter a valid email address.
        </mat-error>
      </mat-form-field>
      <p>
        <strong>Phone Number:</strong>
      </p>
      <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
        <input matInput mask="(000) 000-0000" formControlName="phone"/>
        <mat-error *ngIf="personalInfoForm.get('phone')?.hasError('required')">
          Phone is required.
        </mat-error>
      </mat-form-field>
      <p *ngIf="userAccountType !== AllAccountTypes.REFERRAL_PARTNER && userDetails?.faxNumber">
        <strong>Fax Number:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput mask="(000) 000-0000" formControlName="faxNumber"/>
        </mat-form-field>
      </p>
      <p *ngIf="userAccountType !== AllAccountTypes.REFERRAL_PARTNER && userAccountType !== AllAccountTypes.ADMIN">
        <strong>Address:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput type="text" formControlName="address"/>
          <mat-error *ngIf="personalInfoForm.get('address')?.hasError('required')">
            Address is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput type="text" formControlName="city"/>
          <mat-error *ngIf="personalInfoForm.get('city')?.hasError('required')">
            City is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <mat-select formControlName="state">
            @for (state of us_states_list; track state) {
              <mat-option [value]="state.value">{{state.label}}</mat-option>
            }
          </mat-select>
          <mat-error *ngIf="personalInfoForm.get('state')?.hasError('required')">
            State is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input
            matInput
            maxlength="5"
            formControlName="zipcode"
            type="text"
            inputmode="numeric"
            pattern="\d*"
            mask="00000"
          >
          <mat-error *ngIf="personalInfoForm.get('zipcode')?.hasError('required')">
            Zip code is required.
          </mat-error>
          <mat-error *ngIf="personalInfoForm.get('zipcode')?.hasError('pattern')">
            Zip code must be 5 digits.
          </mat-error>        </mat-form-field>
      </p>
    </form>

    <p *ngIf="userAccountType === AllAccountTypes.REFERRAL_PARTNER">
    <form [formGroup]="referralValues" *ngIf="userAccountType === AllAccountTypes.REFERRAL_PARTNER">
      <strong>Job Title:</strong>
      <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
        <input matInput type="text" formControlName="jobTitle"/>
        <mat-error *ngIf="referralValues.get('jobTitle')?.hasError('required')">
          Job Title is required.
        </mat-error>
      </mat-form-field>
    </form>
  </div>
</ng-template>

<ng-template #clinicProviderInfoEditModeTemplate>
  <app-clinic-provider-info-section
    [mode]="'edit'"
    [firstClinicProps]="firstClinicProps"
    [secondClinicProps]="secondClinicProps"
    [firstClinicCtrl]="firstClinicCtrl"
    [firstProvidersCtrl]="firstProvidersCtrl"
    [secondClinicCtrl]="secondClinicCtrl"
    [secondProvidersCtrl]="secondProvidersCtrl"
    (firstClinicOtherProviderRemoved)="onFirstClinicOtherProviderRemoved()"
    (secondClinicOtherProviderRemoved)="onSecondClinicOtherProviderRemoved()"
    (firstClinicRemoveRequestRemoved)="onFirstClinicRemovalRequestRemoved()"
    (secondClinicRemoveRequestRemoved)="onSecondClinicRemovalRequestRemoved()"
    [allowSecondProviderRemoval]="true"
  >
  </app-clinic-provider-info-section>
</ng-template>

<ng-template #readOnlyModeTemplate>
  <div  class="user-info-modal">
    <h1 class="text-2xl">{{userDetails?.firstName}} {{userDetails?.lastName}}</h1>
    <ng-container *ngIf="userDetails.lastLogin !== null"><p class="mt-2">
      <strong>Last Login:</strong> {{userDetails.lastLogin | dateFormat}}</p></ng-container>
    <ng-container *ngTemplateOutlet="personalInfoReadOnlyModeTemplate;"></ng-container>
    <ng-container *ngTemplateOutlet="companyInfoReadOnlyModeTemplate;"></ng-container>
    <ng-container *ngIf="userAccountType !== AllAccountTypes.REFERRAL_PARTNER">
      <ng-container *ngTemplateOutlet="caseContactSection;"></ng-container>
    </ng-container>
    <ng-container *ngIf="userAccountType === AllAccountTypes.REFERRAL_PARTNER && clinicsList.length > 0 && providersList.length > 0">
      <ng-container *ngTemplateOutlet="clinicProviderInfoReadOnlyModeTemplate;"></ng-container>
    </ng-container>
  </div>
  <div mat-dialog-actions class="action-items-container">
    <div>
      <app-secondary-action-button
        [buttonText]="'Edit User'"
        (clickEmitter)="onEditUser()">
      </app-secondary-action-button>
    </div>
    <div class="flex gap-4">
      <app-secondary-action-button
        [buttonText]="'Deny'"
        (clickEmitter)="onDenyUser()">
      </app-secondary-action-button>
      <app-primary-action-button
        [buttonText]="'Approve'"
        (clickEmitter)="onApproveUser()">
      </app-primary-action-button>
    </div>
  </div>
</ng-template>

<ng-template #personalInfoReadOnlyModeTemplate>
  <div class="mt-4">
    <h2 class="text-lg mb-1"><strong>Personal Information:</strong></h2>
    <hr class="bg-green mb-2" style="height: 2px;"/>
    <p>
      <strong>User Type:</strong> {{userAccountTypeId | accountTypeName}}
    </p>
    <ng-container *ngIf="!hideEmailVerification; else existingUserEmailField">
      <div
        class="email-address-container flex-col sm:flex-row"
        [ngClass]="{
                'email-verified': emailVerifiedControl.value,
                'email-unverified': !emailVerifiedControl.value,
                'email-error': emailVerifiedControl.invalid && emailVerifiedControl.touched
            }"
      >
        <p class="email-address"><strong>Email Address:</strong> {{userDetails?.email}}</p>
        <app-colored-pill
          [bgColor]="emailStatusBgColor"
          [textColor]="emailStatusTextColor"
          [borderColor]="emailStatusBorderColor"
          [text]="emailStatusText">
        </app-colored-pill>
      </div>
      <div class="-mt-1" *ngIf="!hideEmailVerification">
        <input type="checkbox" class="cursor-pointer" id="email-verified-checkbox" [formControl]="emailVerifiedControl" />
        <label class="ml-2 text-xs" for="email-verified-checkbox">This email has been manually verified outside the system.</label>
        <div *ngIf="emailVerifiedControl.invalid && emailVerifiedControl.touched" class="text-xs text-red-600 mt-2">
          Email must be manually verified before approval.
        </div>
      </div>
    </ng-container>
    <ng-template #existingUserEmailField>
      <p>
        <strong>Email Address:</strong> {{userDetails?.email}}
      </p>
    </ng-template>
    <p [ngClass]="{'mt-2': !hideEmailVerification}">
      <strong>Phone Number:</strong> {{userDetails.phoneNumber | phoneFormat}}
    </p>
    <p *ngIf="userAccountType === AllAccountTypes.REFERRAL_PARTNER">
      <strong>Job Title:</strong> {{toReferralUser(userDetails).jobTitle}}
    </p>
    <p *ngIf="userAccountType !== AllAccountTypes.REFERRAL_PARTNER && userDetails?.faxNumber">
      <strong>Fax Number:</strong> {{userDetails.faxNumber | phoneFormat}}
    </p>
    <p *ngIf="userAccountType !== AllAccountTypes.REFERRAL_PARTNER">
      <strong>Address:</strong> {{userDetails?.address}}, {{userDetails?.city}}, {{userDetails?.state}} {{userDetails?.postalCode}}
    </p>
  </div>
</ng-template>

<ng-template #companyInfoReadOnlyModeTemplate>
  <div class="mt-4">
    <h2 class="text-lg mb-1"><strong>Company Information:</strong></h2>
    <hr class="bg-green mb-2" style="height: 2px;"/>
    <p>
      <strong>Manager's First Name:</strong> {{toWorkCompUser(userDetails).managerFirstName}}
    </p>
    <p>
      <strong>Manager's Last Name:</strong> {{toWorkCompUser(userDetails).managerLastName}}
    </p>
    <p>
      <strong>Manager's Email Address:</strong> {{toWorkCompUser(userDetails).managerEmail}}
    </p>
    <p *ngIf="userAccountType !== AllAccountTypes.REFERRAL_PARTNER">
      <strong>Company Name:</strong> {{toWorkCompUser(userDetails).companyName}}
    </p>
    <p>
      <strong>Fax # For Information:</strong> {{toWorkCompUser(userDetails).faxForInformation | phoneFormat}}
    </p>
    <p>
      <strong>Fax # For Chart Notes:</strong> {{toWorkCompUser(userDetails).faxForChartNote | phoneFormat}}
    </p>
  </div>
</ng-template>

<ng-template #companyInfoEditModeTemplate>
  <form [formGroup]="companyInfoFormGroup">
    <div class="mt-4">
      <h2 class="text-lg mb-1"><strong>Company Information:</strong></h2>
      <hr class="bg-green mb-2" style="height: 2px;"/>
      <p>
        <strong>Manager's First Name:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput type="text" formControlName="managerFirstName"/>
          <mat-error *ngIf="companyInfoFormGroup.get('managerFirstName')?.hasError('required')">
            First Name is required.
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <strong>Manager's Last Name:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput type="text" formControlName="managerLastName"/>
          <mat-error *ngIf="companyInfoFormGroup.get('managerLastName')?.hasError('required')">
            Last Name is required.
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <strong>Manager's Email Address:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput type="text" formControlName="managerEmail"/>
          <mat-error *ngIf="companyInfoFormGroup.get('managerEmail')?.hasError('required')">
            Email is required.
          </mat-error>
          <mat-error *ngIf="companyInfoFormGroup.get('managerEmail')?.hasError('email')">
            Please enter a valid email.
          </mat-error>
        </mat-form-field>
      </p>
      <p *ngIf="userAccountType !== AllAccountTypes.REFERRAL_PARTNER">
        <strong>Company Name:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput type="text" formControlName="companyName"/>
          <mat-error *ngIf="companyInfoFormGroup.get('companyName')?.hasError('required')">
            Company Name is required.
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <strong>Fax # For Information:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput mask="(000) 000-0000" formControlName="faxForInformation"/>
          <mat-error *ngIf="companyInfoFormGroup.get('faxForInformation')?.hasError('required')">
            Fax number for information is required.
          </mat-error>
          <mat-error *ngIf="companyInfoFormGroup.get('faxForInformation')?.hasError('mask')">
            Invalid fax number format.
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <strong>Fax # For Chart Notes:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput mask="(000) 000-0000" formControlName="faxForChartNote"/>
          <mat-error *ngIf="companyInfoFormGroup.get('faxForChartNote')?.hasError('required')">
            Fax number for chart note is required.
          </mat-error>
          <mat-error *ngIf="companyInfoFormGroup.get('faxForChartNote')?.hasError('mask')">
            Invalid fax number format.
          </mat-error>
        </mat-form-field>
      </p>
    </div>
  </form>
</ng-template>


<ng-template #clinicProviderInfoReadOnlyModeTemplate>
  <app-clinic-provider-info-section
    [mode]="'readOnly'"
    [firstClinicProps]="firstClinicProps"
    [secondClinicProps]="secondClinicProps"
  >
  </app-clinic-provider-info-section>
</ng-template>

<ng-template #caseContactSection>
  <div class="mt-4">
    <form [formGroup]="workCompFormGroup">
      <h2 class="text-lg mb-1"><strong>NextGen Case Contact:</strong></h2>
      <hr class="bg-green mb-2" style="height: 2px;"/>
      <mat-form-field class="w-full">
        <mat-select
          #caseContactSelect
          placeholder="Select a NextGen Case Contact"
          formControlName="caseContactId"
          (selectionChange)="onCaseContactSelectionChange($event.value)"
        >
          <mat-option>
            <ngx-mat-select-search
              [formControl]="caseContactSearchControl"
              [noEntriesFoundLabel]="noCaseContactsFoundText"
              placeholderLabel="Start typing to find case contact">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let caseContact of caseContactsList" [value]="caseContact.caseContactId || caseContact.id">
            {{ caseContact.firstName || 'No first name' }} {{ caseContact.lastName || 'No last name' }} - {{ caseContact.email || 'No email' }}
          </mat-option>
          <mat-option *ngIf="caseContactsList.length === 0" [disabled]="true" [value]="null">No contacts available</mat-option>
        </mat-select>
        <mat-error *ngIf="workCompFormGroup?.get('caseContactId')?.hasError('required')">
          A case contact is required
        </mat-error>
      </mat-form-field>
    </form>
  </div>
</ng-template>
